import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {onMounted} from "@vue/runtime-core";
import {ref} from "vue";
import {useDataStore} from "@/shared";


export default /*#__PURE__*/_defineComponent({
  __name: 'google-map',
  setup(__props) {

const {getGoogleMapApiKey, getMapLanguage} = useDataStore();
const google = ref();
const runpayGoogleMap = ref();

onMounted(async () => {
  initGoogleMapScript();
});

/**
 * Инициализация скрипта
 */
const initGoogleMapScript = async () => {
  const exist = document.getElementById(
    getGoogleMapApiKey(),
  ) as HTMLScriptElement;

  if (!exist) {
    let script = document.createElement("script");
    script.setAttribute("id", getGoogleMapApiKey());
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${getGoogleMapApiKey()}&language=${getMapLanguage()}&sensor=true&libraries=places&callback=Function.prototype`;
    document.head.append(script);
    script.onload = () => {
      google.value = (window as any).google;
      initGoogleMapSettings();
    };
  } else {
    google.value = (window as any).google;
    initGoogleMapSettings();
  }
};

/**
 * Инициализация опций карты
 */
const initGoogleMapSettings = async () => {
  const position = new google.value.maps.LatLng(56.938975, 24.138538);
  runpayGoogleMap.value = new google.value.maps.Map(runpayGoogleMap.value, {
    zoom: 18,
    center: position,
    mapTypeId: "terrain",
  });

  const marker = new google.value.maps.Marker({
    position: position,
    map: runpayGoogleMap.value,
    animation: google.value.maps.Animation.DROP,
    label: {
      text: "Runpay",
      className: "marker-label",
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "runpayGoogleMap",
    ref: runpayGoogleMap,
    class: "runpay-google-map"
  }, null, 512))
}
}

})